import { tw } from '@ctw/shared/utils/tailwind';

export type ErrorMessageProps = {
  title?: string;
  message: string;
};

const ErrorMessage = ({ title, message }: ErrorMessageProps) => (
  <div className={tw`mx-2 flex h-full flex-col items-center justify-center gap-2`}>
    {title && <div className={tw`text-xl`}>{title}</div>}
    <div className={tw`text-xl`}>{message}</div>
  </div>
);

export default ErrorMessage;
